module.exports = __webpack_public_path__ + "static/media/rewardsGreetingSplashScreenBgImage.0de17106.svg";